import React from "react";
import "./resume.css";
import Menu from "../../components/menu/menu";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdOutlineWorkOutline, MdSchool } from "react-icons/md";
import { AiOutlineDownload } from "react-icons/ai";
import Curriculo from "../../assets/pdf/Leonardo Oliveira Souza.pdf";

const Resume = () => {
  const experiences = [
    {
      date: "out/2023 – atual | Belo Horizonte – MG",
      title: "Squad Leader",
      company: "Construsite Brasil",
      icon: <MdOutlineWorkOutline />,
      description: [
        "Liderança técnica da equipe, apoiando o desenvolvimento e evolução dos membros",
        "Definição de arquitetura e padrões de desenvolvimento",
        "Desenvolvimento e evolução de APIs REST com Laravel, incluindo autenticação, validações complexas e integrações externas",
        "Desenvolvimento de interfaces com React e Next.js",
        "Desenvolvimento e manutenção de e-commerces, sites institucionais, CRMs, CMS e Intranet",
        "Integrações assíncronas com AJAX e manipulação avançada de DOM",
        "Realização de code reviews e aplicação de boas práticas (SOLID, Clean Code)",
        "Utilização de Docker para padronização de ambientes de desenvolvimento",
        "Atuação em ambiente Linux com uso frequente de terminal e scripts Bash",
        "Participação em pipeline de CI/CD com revisão de builds e processos de deploy",
      ],
    },
    {
      date: "dez/2022 – out/2023 | Belo Horizonte – MG",
      title: "Desenvolvedor Web",
      company: "Construsite Brasil",
      icon: <MdOutlineWorkOutline />,
      description: [
        "Desenvolvimento de sistemas web em PHP com implementação de regras de negócio",
        "Criação e consumo de APIs REST com Laravel",
        "Integração com serviços externos e APIs de terceiros",
        "Manutenção evolutiva e corretiva de sistemas legados (e-commerces, CRMs, CMSs)",
        "Melhorias estruturais visando organização e performance de aplicações",
        "Uso de jQuery e AJAX para aumento de interatividade",
        "Versionamento com Git seguindo boas práticas (branching, code review)",
      ],
    },
    {
      date: "ago/2022 – dez/2022 | Belo Horizonte – MG",
      title: "Estagiário de Desenvolvimento Web PHP",
      company: "Construsite Brasil",
      icon: <MdOutlineWorkOutline />,
      description: [
        "Implementação de funcionalidades seguindo especificações técnicas",
        "Correção de bugs e ajustes em regras de negócio",
        "Evolução para desenvolvimento de funcionalidades completas em PHP",
      ],
    },
    {
      date: "02/2022 – 06/2022",
      title: "Desenvolvedor Python",
      company: "Whobots",
      icon: <MdSchool />,
      description: [
        "Auxílio no desenvolvimento de chatbots para o Telegram.",
      ],
    },
  ];

  return (
    <>
      <Menu url="resume" />
      <main className="resume-page">
        <div className="resume-container">
          {/* Header */}
          <section className="resume-header">
            <h1 className="resume-page-title">
              Experiências Profissionais
            </h1>
            <p className="resume-subtitle">
              Confira minha trajetória e competências desenvolvidas ao longo dos anos
            </p>
            <div className="header-divider"></div>

            {/* Botão Download */}
            <a 
              href={Curriculo} 
              download="Leonardo Souza - Currículo.pdf"
              className="btn  btn-project-primary btn-download"
              aria-label="Baixar currículo em PDF"
            >
              <AiOutlineDownload className="btn-icon" />
              Baixar Currículo
            </a>
          </section>

          {/* Timeline */}
          <section className="resume-timeline-section">
            <VerticalTimeline>
              {experiences.map((exp, index) => (
                <VerticalTimelineElement
                  key={index}
                  date={exp.date}
                  dateClassName="timeline-date"
                  icon={exp.icon}
                  iconClassName="timeline-icon"
                  contentClassName="timeline-content"
                >
                  <article className="experience-card">
                    <header className="experience-header">
                      <h3 className="experience-title">{exp.title}</h3>
                      <p className="experience-company">{exp.company}</p>
                    </header>

                    {/* Descrição */}
                    <div className="experience-description">
                      {exp.description.length > 1 ? (
                        <ul className="description-list">
                          {exp.description.map((item, idx) => (
                            <li key={idx}>{item}</li>
                          ))}
                        </ul>
                      ) : (
                        <p>{exp.description[0]}</p>
                      )}
                    </div>
                  </article>
                </VerticalTimelineElement>
              ))}
            </VerticalTimeline>
          </section>
        </div>
      </main>
    </>
  );
};

export default Resume;
